// Prueba aislada en una página del mismo dominio para conservar el origen autorizado.
export function probeGoogle(config) {
  return new Promise(resolve => {
    const frame = document.createElement('iframe');
    frame.title = 'Prueba de servicios Google';
    frame.style.cssText = 'position:fixed;width:320px;max-width:calc(100vw - 32px);height:240px;right:16px;top:80px;z-index:1100;border:1px solid #d9d9d9;border-radius:8px;background:white;box-shadow:0 4px 20px #0003';
    const nonce = `${Date.now()}-${Math.random()}`;
    const operations = ['map','street_view','search','reverse','route'];
    const failure = code => ({browser:Object.fromEntries(operations.map(op=>[op,false])),browser_errors:Object.fromEntries(operations.map(op=>[op,code]))});
    let done=false,started=false;
    const finish = report => {
      if(done)return;done=true;clearTimeout(timeout);window.removeEventListener('message',receive);frame.remove();resolve(report);
    };
    const receive = event => {
      if(event.origin!==window.location.origin || event.source!==frame.contentWindow)return;
      if(event.data?.type==='geo-probe-ready' && !started){
        started=true;
        // No enviar credenciales privadas ni el resto de la configuración al iframe.
        frame.contentWindow.postMessage({type:'geo-probe-start',nonce,config:{google:{browser_key:config.google.browser_key,map_id:config.google.map_id},execution:config.execution}},window.location.origin);
      }
      if(event.data?.type==='geo-probe-result' && event.data.nonce===nonce){
        const report=event.data.report;
        if(operations.every(op=>typeof report?.browser?.[op]==='boolean'))finish(report);
      }
    };
    const timeout=setTimeout(()=>finish(failure('PROBE_TIMEOUT')),45000);
    window.addEventListener('message',receive);
    frame.onerror=()=>finish(failure('SCRIPT_LOAD_ERROR'));
    frame.src='/geo-google-probe.html';
    document.body.appendChild(frame);
  });
}
